import { CLEAR_ERROR } from "../../constants/error";

export const clearError = () => dispatch => {
  dispatch({
    type: CLEAR_ERROR
  });
};
